const SUFFIX = "Cheet.io";

export function PageTitle({ title }: { title?: string }) {
  return <title>{title ? `${title} — ${SUFFIX}` : SUFFIX}</title>;
}
